/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-restricted-globals */
import clsx from 'clsx'
import React, { FC, useState, useEffect, useContext, useRef, useCallback } from 'react'
import { KTSVG } from '../../../helpers'
import { HeaderUserMenu } from '../../../partials'
import { useLayout } from '../../core'
import userPermissionContext from '../../../../context/userPermissionContext'
import Select from 'react-select'
import {
	BusinessUnitOption,
	clearVmsSessionAndReload,
	loadUserBusinessContext,
} from '../../../../app/auth/loadAuthContext'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
	toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

const customStylesSelect = {
	control: (provided: any) => ({
		...provided,
		height: 'calc(1.5em + 1.3rem + 2px)',
		marginTop: '0px',
	}),
	valueContainer: (provided: any) => ({
		...provided,
		height: 'calc(1.5em + 1.3rem + 2px)',
		minWidth: '200px',
		maxWidth: 'min(320px, 42vw)',
	}),
	menu: (provided: any) => ({
		...provided,
		zIndex: 1080,
	}),
}

const Topbar: FC = () => {
	const { config } = useLayout()
	const [allBusinessUnits, setAllBusinessUnits] = useState<BusinessUnitOption[]>([])
	const [buListLoading, setBuListLoading] = useState(true)
	const [buFetchFailed, setBuFetchFailed] = useState(false)
	const { businessUnit, changeBusinessUnit } = useContext(userPermissionContext)
	const [bu, setBu] = useState<BusinessUnitOption | null>(null)
	const [fullname, setFullname] = useState<string | null>(null)
	const [pic, setPic] = useState<string | null>(null)
	const loadGen = useRef(0)

	useEffect(() => {
		const hasProject =
			businessUnit &&
			typeof businessUnit === 'object' &&
			'idProjects' in businessUnit &&
			businessUnit.projectName != null
		if (hasProject) {
			setBu({
				label: businessUnit.projectName,
				value: businessUnit.idProjects,
				idProjects: businessUnit.idProjects,
				projectName: businessUnit.projectName,
			})
		} else {
			setBu(null)
		}
	}, [businessUnit, allBusinessUnits])

	const executeTopbarLoad = useCallback(async (gen: number) => {
		setBuListLoading(true)
		setBuFetchFailed(false)
		try {
			const payload = await loadUserBusinessContext()
			if (gen !== loadGen.current) return
			if (payload === 'no-token') {
				setFullname(null)
				setPic(null)
				setAllBusinessUnits([])
				setBuListLoading(false)
				return
			}
			if (payload === 'unauthorized') {
				clearVmsSessionAndReload()
				return
			}
			setFullname(payload.fullName)
			setPic(payload.fileName)
			setAllBusinessUnits(payload.options)
			setBuListLoading(false)
		} catch {
			if (gen !== loadGen.current) return
			setBuFetchFailed(true)
			setAllBusinessUnits([])
			setBuListLoading(false)
		}
	}, [])

	useEffect(() => {
		const gen = ++loadGen.current
		void executeTopbarLoad(gen)
	}, [executeTopbarLoad])

	const retryLoad = () => {
		const gen = ++loadGen.current
		void executeTopbarLoad(gen)
	}

	const handleBusinessUnitChange = (unit: BusinessUnitOption | null) => {
		if (!unit) {
			return
		}
		setBu(unit)
		changeBusinessUnit(unit)
	}

	const hasOptions = allBusinessUnits.length > 0
	const selectDisabled = buListLoading || (buFetchFailed && !hasOptions)
	const placeholder = buListLoading
		? 'Loading…'
		: buFetchFailed
			? 'Load failed — use Retry'
			: !hasOptions
				? 'No business units'
				: 'Business unit'

	return (
		<div className='d-flex align-items-stretch flex-shrink-0 flex-nowrap'>
			<div className='d-flex align-items-center me-2 me-lg-3' style={{ minWidth: 0 }}>
				<Select<BusinessUnitOption>
					inputId='header-business-unit'
					aria-label='Business unit'
					value={bu}
					onChange={handleBusinessUnitChange}
					options={allBusinessUnits}
					styles={customStylesSelect}
					placeholder={placeholder}
					isClearable={false}
					isSearchable={!buListLoading && hasOptions}
					isLoading={buListLoading}
					isDisabled={selectDisabled}
					noOptionsMessage={() => (buFetchFailed ? 'Use Retry or sign in again' : 'No options')}
				/>
				{buFetchFailed && !buListLoading && (
					<button
						type='button'
						className='btn btn-sm btn-light-primary ms-2 text-nowrap'
						onClick={retryLoad}
					>
						Retry
					</button>
				)}
			</div>

			<div
				className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
				id='kt_header_user_menu_toggle'
			>
				<div
					className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
					data-kt-menu-trigger='click'
					data-kt-menu-attach='parent'
					data-kt-menu-placement='bottom-end'
					data-kt-menu-flip='bottom'
				>
					{fullname !== null && (
						<>
							<img src={`${process.env.REACT_APP_USER_ASSET}${pic}`} alt='user' />{' '}
							<span
								className='text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3'
								style={{ color: 'rgb(255, 255, 255)' }}
							>
								{fullname}
							</span>
						</>
					)}
				</div>
				<HeaderUserMenu />
			</div>

			{config.header.left === 'menu' && (
				<div className='d-flex align-items-center d-lg-none ms-2 me-n3' title='Show header menu'>
					<div
						className='btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px'
						id='kt_header_menu_mobile_toggle'
					>
						<KTSVG path='/media/icons/duotune/text/txt001.svg' className='svg-icon-1' />
					</div>
				</div>
			)}
		</div>
	)
}

export { Topbar }
